import React from "react";
import styled from "styled-components";
import productBG from "../../../../../shared-styles/productBG";

export default styled.div`
  ${(props) => productBG({}, props.isCoffee)}
  overflow: hidden;
`;
